<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="datas">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ADD NEW -->
          <div v-if="position === 'แผนก IT'" class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">เพิ่มข้อมูล</span>
          </div>
        </div>

      </div>

      <template slot="thead">
        <vs-th>ลำดับที่</vs-th>
        <vs-th sort-key="usernameId">ชื่อเข้าใช้งาน</vs-th>
        <vs-th sort-key="userFullname">ชื่อ-สกุล</vs-th>
        <vs-th sort-key="positionname">ตำแหน่ง/แผนก</vs-th>
        <vs-th sort-key="P32Key">เพิ่ม</vs-th>
        <vs-th sort-key="P31Key">แก้ไข</vs-th>
        <vs-th sort-key="ReportKey">ลบ</vs-th>
        <vs-th sort-key="AdminKey">admin</vs-th>
        <vs-th sort-key="BasicKey">basic</vs-th>
<!--        <vs-th>คำสั่ง</vs-th>-->
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium">{{ indextr + 1 }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">{{ tr.usernameId }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">{{ tr.userFullname }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">{{ tr.positionname }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">{{ tr.P32Key }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">{{ tr.P31Key }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">{{ tr.ReportKey }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">{{ tr.AdminKey }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium">{{ tr.BasicKey }}</p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon v-if="position === 'แผนก IT'" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
<!--                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './UserViewSidebar.vue'
import moduleUser from "@/store/user/moduleUser.js"

export default {
  components: {
    DataViewSidebar
  },
  data() {
    return {
      position: '',
      selected: [],
      // products: [],
      itemsPerPage: 20,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    datas() {
      return this.$store.state.user.items
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  methods: {
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData(id) {
      this.$store.dispatch("user/removeItem", id).then(() => {
        this.$store.dispatch("user/fetchDataListItems")
      })
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    }
  },
  created() {
    if(!moduleUser.isRegistered) {
      this.$store.registerModule('user', moduleUser)
      moduleUser.isRegistered = true
    }
    const user = JSON.parse(sessionStorage.getItem('vuex'));
    this.position = user.owner.user.user.positionname;
    this.$store.dispatch("user/fetchDataListItems")
  },
  mounted() {
    this.isMounted = true;
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
